import { Switch as AntSwitch } from "antd";

const Switch = AntSwitch;

export default Switch;
